import { LAYER_TYPES } from '@App/app/entities/layer/enums/layer-types.enum';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Mesh } from 'babylonjs';
import { CUBOID_OBJECT_NAME, RECT_TUBE_OBJECT_NAME } from '@App/app/configs/babylon.config';
import { editLayer } from '@App/app/pages/viewer/store/actions/layers.actions';
import { UtilsService } from '../../../utils-service/utils.service';
import { ViewerLayerTypedOpsService } from '../../viewer-layer-service/viewer-layer-typed-ops.service';
import { VolumeUtilsService } from './volume-utils.service';

@Injectable({
  providedIn: 'root',
})
export class RectangleToolsAzimuthService {
  constructor(
    private utilsService: UtilsService,
    private volumeUtilsService: VolumeUtilsService,
    private viewerLayerTypedOps: ViewerLayerTypedOpsService,
    // eslint-disable-next-line ngrx/use-consistent-global-store-name
    private store: Store,
  ) {}

  findAzimuthAndVerticalTilt(type: LAYER_TYPES.RECT_TUBE | LAYER_TYPES.CUBOID): void {
    const objectName = this.rectangleObjectName(type);
    const hit = this.utilsService.pickRay((mesh: Mesh) => mesh.name.includes(objectName));
    if (!hit?.pickedMesh) {
      return;
    }
    const meshId = hit.pickedMesh.id;
    if (!meshId.includes(objectName)) {
      return;
    }
    const id = +meshId.replace(/[^0-9]/g, '');
    const normal = hit.getNormal(true);
    if (normal) {
      const azimuth = this.volumeUtilsService.calculateAzimuth(normal);
      const verticalTilt = this.volumeUtilsService.calculateVerticalTilt(normal);
      this.viewerLayerTypedOps.setTmpData(id, { azimuth, verticalTilt });
      this.store.dispatch(editLayer({ id }));
    }
  }

  private rectangleObjectName(type: LAYER_TYPES.RECT_TUBE | LAYER_TYPES.CUBOID) {
    return type === LAYER_TYPES.RECT_TUBE ? RECT_TUBE_OBJECT_NAME : CUBOID_OBJECT_NAME;
  }
}
